import React from "react";
import { AllCoObjectsSelector } from "../../components/generic/AllCoObjectsSelector";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { MoveObject } from "../../components/coobjects/MoveObject";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";

export const MoveObjectPage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent
      userFunction={UserFunctionEnum.MENU_EDIT_OBJECT}
      protectionType={true}
      errorComponent={<UnauthorizedError />}
    >
      <CoRetrieveDocumentData>
        {({ coObject }) =>
          coObject?.documentId ? (
            <AllCoObjectsSelector>
              {(coObjectsArray) => (
                <MoveObject
                  documentCoObjects={coObjectsArray.filter(
                    (coObject) => coObject.info.objectType != "DOCUMENT_PART_INCLUDE"
                  )}
                />
              )}
            </AllCoObjectsSelector>
          ) : (
            <DocumentNotValidError />
          )
        }
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
